import {
	AddressModel,
	COMPANY_STATUS_KEY_TYPE,
	DEFAULT_ADDRESS,
	DEFAULT_EMPLOYEE,
	DEFAULT_TAX_ACCOUNTANT_NAME,
	DEFAULT_TAX_CORPORATION_NAME,
	EmployeeModel,
	REGISTER_STATUS_KEY_TYPE,
	STATUS_KEY_TYPE,
	TaxAccountantNameModel,
	TaxCorporationNameModel
} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	areaBlock: z.boolean(),
	updatedAt: z.string().nullable(),
	registerStatus: REGISTER_STATUS_KEY_TYPE.nullable().default("PENDING"),
	taxAccountantId: z.string(),
	taxAccountantName: TaxAccountantNameModel.model,
	taxCorporationName: TaxCorporationNameModel.model,
	belongTo: z.string().nullable().default(""),
	address: AddressModel.model,
	tel: z.string().nullable().default(""),
	status: STATUS_KEY_TYPE.nullable().default("UNKNOWN"),
	managerEmployee: EmployeeModel.model.nullable().default(DEFAULT_EMPLOYEE),
	companyStatus: COMPANY_STATUS_KEY_TYPE.nullable().default("UNKNOWN"),
	resignedReason: z.string().nullable().default(""),
	etc: z.string().nullable().default(""),
	registeredDate: z.string().nullable(),
	//new
	areaBlockLocation: z.string().nullable().default(""),
	areaBlockLocationDetail: z.string().nullable().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const SimpleResModel = { schema, model };
export type ISimpleResModel = z.infer<typeof SimpleResModel.model>;
export const DEFAULT_SIMPLE_RES: ISimpleResModel = {
	updatedAt: null,
	areaBlock: false,
	taxAccountantId: "",
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	taxCorporationName: DEFAULT_TAX_CORPORATION_NAME,
	belongTo: "",
	address: DEFAULT_ADDRESS,
	tel: "000-0000-0000",
	registerStatus: "PENDING",
	status: "UNKNOWN",
	managerEmployee: DEFAULT_EMPLOYEE,
	companyStatus: "UNKNOWN",
	resignedReason: "",
	etc: "",
	registeredDate: null,
	areaBlockLocation: "",
	areaBlockLocationDetail: ""
};
